import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Breadcrumb from 'components/Admin/Breadcrumb';
import { Link } from 'react-router-dom';
import Alert from 'components/Alert';
import moment from 'moment';
import { toast } from 'react-toastify';
import { donationListService, getPaymentReceiptService, donationPaymentConfirmService } from './DonationList.service.js';
import { useTranslation } from 'react-i18next';

function DonationList() {
	const [donation, setDonation] = useState([]);
	const [donationMeta, setDonationMeta] = useState({});
	const [page, setPage] = useState(1);
	const [alertType, SetAlertType] = useState('');
	const [alertMessage, SetAlertMessage] = useState('');
	const [donationId, setDonationId] = useState('');
	const [paymentReceipt, setPaymentReceipt] = useState({});
	const { t } = useTranslation();

	useEffect(() => {
		getDonationList();
	}, []);

	const getDonationList = async () => {
		const list = await donationListService(page);
		if (list.data.status === 200) {
			setDonation(list.data.data.records);
			setDonationMeta(list.data.data.meta);
		} else {
			toast.error(list.data.error);
		}
	};

	const confirmPayment = async () => {
		let formData = {
			donation_id: donationId,
		};
		let result = await donationPaymentConfirmService(formData);
		if (result.data.status === 200) {
			await getDonationList();
			document.querySelector('#confirmPaymentModalClose').click();
			toast.success(`${t('donation_list.payment_confirmed')} !`);
		} else {
			toast.error(result.data.error);
			window.scrollTo(0, 0);
		}
	};
	const showPaymentReceipt = async (id) => {
		setDonationId(id);
		let result = await getPaymentReceiptService(id);

		if (result.data.status === 200) {
			setPaymentReceipt(result.data.data.payment_receipt);
		} else {
			toast.error(result.data.error);
		}
	};

	const columns = [
		{
			name: t('admin_my_donation.campaign_titile'),
			selector: (row) => row?.get_raise_fund?.campaign_title?.en,
			sortable: true,
		},
		{
			name: t('admin_my_donation.donation_amount'),
			selector: (row) => row?.amount,
			sortable: true,
		},
		{
			name: t('donation_list.donated_by'),
			selector: (row) => row?.get_donated_by?.full_name,
			sortable: true,
		},
		{
			name: t('funding_details.payment_method'),
			selector: (row) => {
				let method = '';
				if (row.payment_method === 1) {
					method = t('funding_details.bankili');
				} else if (row.payment_method === 2) {
					method = t('funding_details.masrivi');
				} else if (row.payment_method === 3) {
					method = t('funding_details.saddad');
				} else {
					method = t('funding_details.cash');
				}
				return method;
			},
			sortable: true,
		},
		{
			name: t('admin_my_donation.donation_date'),
			selector: (row) => moment(row.created_at).format('DD-MM-YYYY'),
			sortable: true,
		},
		{
			name: t('admin_my_donation.status'),
			selector: (row) => {
				let status = '';
				if (row.status === 0) {
					status = <span class="badge bg-warning text-dark">{t('admin_my_donation.pending')}</span>;
				}
				if (row.status === 1) {
					status = <span class="badge bg-primary">{t('admin_my_donation.payment_cleared')}</span>;
				}
				if (row.status === 2) {
					status = <span class="badge bg-success">{t('admin_my_donation.accepted')}</span>;
				}
				return status;
			},
			sortable: true,
		},
		{
			name: t('admin_my_donation.action'),
			cell: (row) => (
				<div className="dropdown">
					<div className="actionList " id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
						<svg
							style={{ cursor: 'pointer' }}
							xmlns="http://www.w3.org/2000/svg"
							width={24}
							height={24}
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth={2}
							strokeLinecap="round"
							strokeLinejoin="round"
							className="feather feather-sliders dropdown-toggle"
							data-toggle="dropdown"
							role="button"
							aria-expanded="false"
						>
							<line x1={4} y1={21} x2={4} y2={14} />
							<line x1={4} y1={10} x2={4} y2={3} />
							<line x1={12} y1={21} x2={12} y2={12} />
							<line x1={12} y1={8} x2={12} y2={3} />
							<line x1={20} y1={21} x2={20} y2={16} />
							<line x1={20} y1={12} x2={20} y2={3} />
							<line x1={1} y1={14} x2={7} y2={14} />
							<line x1={9} y1={8} x2={15} y2={8} />
							<line x1={17} y1={16} x2={23} y2={16} />
						</svg>
					</div>
					<div className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
						{row.status === 1 && (
							<>
								<Link
									to="#"
									className="dropdown-item"
									data-bs-toggle="modal"
									data-bs-target="#confirmPaymentModal"
									onClick={() => {
										showPaymentReceipt(row?.id);
									}}
								>
									{t('donation_list.confirm_payment')}
								</Link>
							</>
						)}
					</div>
				</div>
			),
		},
	];
	return (
		<>
			<Breadcrumb data={[{ link: '#', name: t('admin_dashboard_menu.donation_list') }]} title={t('admin_dashboard_menu.donation_list')} />
			{alertType && <Alert type={alertType} message={alertMessage} />}
			<div className="datatable-wrap">
				<DataTable
					columns={columns}
					data={donation}
					striped
					pagination
					paginationServer
					paginationTotalRows={donationMeta.totalRecords}
					paginationPerPage={15}
					paginationComponentOptions={{
						noRowsPerPage: true,
					}}
					onChangePage={(page) => setPage(page)}
				/>
			</div>

			<div
				className="modal fade cmn-modal"
				id="confirmPaymentModal"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex={-1}
				aria-labelledby="confirmPaymentModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-xl">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="confirmPaymentModalLabel">
								{t('donation_list.confirm_payment')}
							</h5>
							<button type="button" className="btn-close" id="confirmPaymentModalClose" data-bs-dismiss="modal" aria-label="Close">
								<i className="far fa-times-circle"></i>
							</button>
						</div>
						<div className="modal-body">
							<div className="payment-receipt">
								<span className="payment-receipt-img">
									<img className="img-block" src={paymentReceipt?.image} alt="payment reciept" />
								</span>
								<span className="payment-btn-wrap cmn-btn-tag-wrap">
									<button type="button" className="cmn-btn-tag" onClick={confirmPayment}>
										{t('donation_list.confirm_payment')}
									</button>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default DonationList;
